<script setup>
import { computed, ref, onMounted, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { useConfig } from 'dashboard/composables/useConfig';

const route = useRoute();
const store = useStore();
const { hostURL } = useConfig();

const iframeRef = ref(null);

const appId = computed(() => Number(route.params.id));
const appData = computed(
  () =>
    store.getters['dashboardApps/getRecords'].find(a => a.id === appId.value) ||
    {}
);

const url = computed(() => appData.value.content?.[0]?.url || '');
const shouldSendCredentials = computed(() => !!appData.value.send_credentials);

const darkMode = computed(() =>
  document.body.classList.contains('dark'));

const appContext = computed(() => {
  if (!shouldSendCredentials.value) return null;
  const token = appData.value.user_access_token || null;
  if (!token) return null;
  return {
    userAccessToken: token,
    accountId: store.getters.getCurrentAccountId,
    chatwootUrl: hostURL || window.location.origin,
    darkMode: darkMode.value,
  };
});

function sendContextToIframe() {
  if (!iframeRef.value || !appContext.value) return;
  const eventData = {
    event: 'appContext',
    data: appContext.value,
  };
  iframeRef.value.contentWindow.postMessage(
    JSON.stringify(eventData),
    '*'
  );
}

function handleMessage(event) {
  if (event.data === 'chatwoot-dashboard-app:fetch-info') {
    sendContextToIframe();
  }
}

function handleIframeLoad() {
  sendContextToIframe();
}

onMounted(() => {
  if (!store.getters['dashboardApps/getRecords'].length) {
    store.dispatch('dashboardApps/get');
  }
  window.addEventListener('message', handleMessage);
});

onUnmounted(() => {
  window.removeEventListener('message', handleMessage);
});
</script>

<template>
  <div class="flex flex-1 h-full overflow-hidden">
    <iframe
      v-if="url"
      ref="iframeRef"
      :src="url"
      class="w-full h-full border-0"
      @load="handleIframeLoad"
    />
  </div>
</template>
